<!--GBMS平台-->
<template>
  <div class="solution1">
    <!--顶部介绍-->
    <div class="x-top">
      <guide :guide="guide"></guide>
      <div class="x-top-container">
        <!--<p class="x-top-container-title">新闻中心</p>-->
      </div>
    </div>
    <!--主体内容-->
    <div class="x-container">
      <!--五个新闻板块-->
      <div class="news">
        <div class="news-block" :class="{bigBlock:index==4?true:false}" v-for="(item,index) in news" :key="index" @click="goDetails(item.id)" style="cursor: pointer;">
          <!--<picture>-->
            <!--<source media="(min-width: 768px)" :srcset="item.img">-->
            <!--<source media="(min-width: 320px)" :srcset="item.img">-->
            <!--<img :srcs="item.img" style="height: 100%;">-->
          <!--</picture>-->
          <img :src="item.img" style="height: 100%;">
          <!--<div class="info">-->
          <!--&lt;!&ndash;注意这个pre标签不能换行，否则会把换行的空格加上&ndash;&gt;-->
          <!--<pre @click="goDetails(item.link)">{{item.label}}</pre>-->
          <!--</div>-->
          <div :class="'box'+index" class="box">
            <div :class="'content'+index" class="content">
              <p class='text' :class="'text'+index" :title="item.label">{{item.label}}</p>
            </div>
          </div>
        </div>
      </div>
      <!--新闻列表-->
      <blueTitle style="display: block;margin: 2rem auto;">最新消息</blueTitle>
      <!--PC端新闻列表-->
      <div class="newsList">
        <ul>
          <div v-for="(item,index) in newsList" :key="index">
            <li @click="goDetails(item.id)"
                v-if="(currentPage-1)*pagesize<=index &&index<currentPage*pagesize">
            <span style="display:inline-block;width: 2rem;">
            {{index+1+'、'}}
            </span>
              <span :title="item.label">
            {{item.label}}
            </span>
            </li>
          </div>
        </ul>
        <el-pagination class="pagination" style="margin-top: 20px;text-align: center"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="currentPage"
                       :page-sizes="[5,10]"
                       :page-size="pagesize"
                       layout="total,sizes, prev, pager, next, jumper"
                       :total="newsList.length">
        </el-pagination>
      </div>
      <!--移动端新闻列表-->
      <div class="newsListMobile">
        <ul
          class="list"
          v-infinite-scroll="load"
          infinite-scroll-disabled="disabled"
        >
          <div v-for="(item,index) in newsList" :key="index">
            <li @click="goDetails(item.id)" class="list-item"
                v-if="index<=count"
            >
              <span style="display:inline-block;width: 2rem;">
              {{index+1+'、'}}
              </span>
              <span >
              {{item.label}}
              </span>
            </li>
          </div>
        </ul>
        <p v-if="loading">加载中...</p>
        <p v-if="noMore">没有更多了</p>
      </div>
    </div>
  </div>
</template>

<script>
  import guide from '@/components/guide'
  import blueTitle from '@/components/blueTitle'
  import {getListNews,getGraphicNews} from '@/api/download'

  export default {
    name: "solution1",
    components: {
      guide,
      blueTitle,
    },
    data() {
      return {
        textWidth: null,
        boxWidth: null,
        guide: [
          // {label: '格力智能楼宇'},
          {label: '关于我们'},
          {label: '最新资讯'},
        ],
        // 上面五个新闻图片
        news: [],
        // 新闻列表
        pagesize: 5,
        currentPage: 1,
        newsList: [],
        // 移动端新闻列表
        count: 10,
        loading: false
      }
    },
    methods: {
      handleSizeChange(val) {
        this.pagesize = val
      },
      handleCurrentChange(val) {
        this.currentPage = val;
      },
      load() {
        this.loading = true
        setTimeout(() => {
          this.count += 5
          this.loading = false
        }, 2000)
      },
      // 跳转到详情页
      goDetails(id) {
        // window.location.href = link;
        this.$router.push('/about/news/'+id)
      },
      // 新闻跑马灯效果(弃用)
      checkScrollLeft(i) {
        let [box, content, text] = [
          document.querySelector('.box' + i),
          document.querySelector('.content' + i),
          document.querySelector('.text' + i)
        ]
        let [textWidth, boxWidth] = [
          text.offsetWidth,
          box.offsetWidth
        ]
        // 判断文字长度是否大于盒子长度
        if (boxWidth > textWidth) {
          return false
        }
        content.innerHTML += content.innerHTML
        // document.querySelector('.text').classList.add('padding')
        // 更新
        textWidth = document.querySelector('.text' + i).offsetWidth
        this.toScrollLeft(i)
      },
      toScrollLeft(i) {
        let [box, content, text] = [
          document.querySelector('.box' + i),
          document.querySelector('.content' + i),
          document.querySelector('.text' + i)
        ]
        let [textWidth, boxWidth] = [
          text.offsetWidth,
          box.offsetWidth
        ]
        //  如果文字长度大于滚动条距离，则递归拖动
        if (textWidth > box.scrollLeft) {
          box.scrollLeft++
          // setTimeout('toScrollLeft()', 18);
          setTimeout(() => {
            this.toScrollLeft(i);
          }, 30);
        }
        else {
          box.scrollLeft = 0;
          box.scrollLeft++
          // setTimeout('toScrollLeft()', 18);
          setTimeout(() => {
            this.toScrollLeft(i);
          }, 30);
          // setTimeout("fun2()",2000);
        }
      },
      checkScroll() {
        this.checkScrollLeft(0);
        this.checkScrollLeft(1);
        this.checkScrollLeft(2);
        this.checkScrollLeft(3);
        this.checkScrollLeft(4);
      },


      getListNews() {
        getListNews().then(res => {
          if (res.returnCode === "100") {

            let arr = [];
            res.returnData.map(item => {
              arr.push({
                label: item.title,
                id: item.id
              })
            });
            this.newsList = arr;
          } else {
            this.newsList = []
          }
        }).catch(e=>{

        })
      },

      getGraphicNews() {
        getGraphicNews().then(res => {
          if (res.returnCode === "100") {
            let arr = [];
            res.returnData.map(item => {
              arr.push({
                label: item.title,
                id: item.id,
                img:this.$commonPicUrl+item.imageUrl
              })
            });
            this.news = arr;
          } else {
            this.news = []
          }
        }).catch(e=>{

        })
      }
    },
    computed: {
      noMore() {
        return this.count >= 20
      },
      disabled() {
        return this.loading || this.noMore
      }
    },
    mounted() {
      // this.checkScroll();
      this.getListNews();
      this.getGraphicNews();
    }
  }
</script>

<style scoped lang="less">
  .pp {
    width: 400px;
    overflow: hidden;
    /* 单行显示 */
    white-space: nowrap;
    /* 字体超出加'...' */
    text-overflow: ellipsis;
  }

  .x-top {
    min-height: 23rem;
    .x-top-img {
      text-align: right;
      img {
        width: 20rem;
      }
    }
  }

  /*新闻板块*/
  .x-container {
    /*新闻概览图*/
    .news {
      margin-top: 1rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      color: #fff;
      .news-block {
        width: 49%;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 2%;
        min-height: 40px;
        &.bigBlock {
          width: 100%;
        }
        img {
          width: 100%;
        }
        .info {
          text-align: left;
          position: absolute;
          bottom: 0;
          background: rgba(0, 0, 0, 0.55);
          width: 100%;
          height: 4rem;
          margin: 0;
          padding-left: 1rem;
          box-sizing: border-box;
          color: #fff;
          cursor: pointer;
          pre {
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 0.5rem;
            font-family: 'Avenir', Helvetica, Arial, sans-serif;
          }
        }
        .content p {
          display: inline-block;
          width: 100%;
          text-overflow: ellipsis;
          overflow: hidden;
          text-align: left;
          padding-left: 1rem;
          box-sizing: border-box;
        }
        .content p.padding {
          padding-right: 300px;
        }
        /*跑马灯*/
        .box {
          position: absolute;
          bottom: 0;
          color: #FFF;
          white-space: nowrap;
          overflow: hidden;
          width: 100%;
          height: 2rem;
          line-height: 2rem;
          background: rgba(0, 0, 0, 0.55);
          font-size: 1rem;
        }
      }
    }
    /*新闻列表*/
    .newsList {
      min-height: 20rem;
      background: #fff;
      border-radius: 25px;
      box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.23);
      padding: 3rem;
      box-sizing: border-box;
      display: block;
      /*新闻列表*/
      ul {
        text-align: left;
        li {
          line-height: 2.5rem;
          color: #1c3663;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &:hover {
            color: @blue;
            cursor: pointer;
          }
        }
      }
      /*分页条*/
      .pagination {
        position: absolute;
        bottom: 1rem;
        left: 0;
        right: 0;
        margin: auto;
      }
    }
    .newsListMobile {
      display: none;
      height: 20rem;
      background: #fff;
      border-radius: 25px;
      box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.23);
      padding: 3rem;
      box-sizing: border-box;
      overflow: auto;
      /*新闻列表*/
      ul {
        text-align: left;
        li {
          line-height: 2.5rem;
          color: #1c3663;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &:hover {
            color: @blue;
            cursor: pointer;
          }
        }
      }
    }
  }
</style>
<style lang="less" scoped>
  @media only screen and (min-width: 320px) {
    .x-top {
      background: url("../../../assets/img/mobile/about/about3/background.png") !important;
      background-repeat: no-repeat !important;
      background-size: cover !important;
      background-position: center center !important;
      box-sizing: border-box !important;
    }

    /*新闻列表*/
    .x-container {
      /*PC端*/
      .newsList {
        display: none !important;
      }
      /*移动端*/
      .newsListMobile {
        display: block !important;
      }
    }
  }

  @media only screen and (min-width: 768px) {
    .x-top {
      background: url("../../../assets/img/pc/about/about3/background.png") !important;
      background-repeat: no-repeat !important;
      background-size: cover !important;
      background-position: center center !important;
      box-sizing: border-box !important;
    }

    /*新闻列表*/
    .x-container {
      /*PC端*/
      .newsList {
        display: block !important;
      }
      /*移动端*/
      .newsListMobile {
        display: none !important;
      }
    }
  }
</style>
